import { useCallback } from 'react';
import { usePlaybackStateStore } from '@annunciate/core';
export const usePlaying = () => {
    const playing = usePlaybackStateStore(useCallback(state => state.content, []));
    const initialPosition = usePlaybackStateStore(useCallback(state => state.initialPosition, []));
    return {
        playing,
        initialPosition,
    };
};
//# sourceMappingURL=usePlaying.js.map